const CONNECTION_TYPES = ['HTTP', 'HTTPS', 'IPMI', 'PING', 'SNMP','SSH', 'WMI']

const useOptions = ({ credentials }) => {
  const credentialOptions = credentials.map(credential => (
    { label: credential.value, value: credential.id }
  ))

  const connectionTypeOptions = CONNECTION_TYPES.map(i => (
    { label: i, value: i }
  ))

  const collectorTypeOptions = [
    { label: 'Linux', value: 'linux' },
    { label: 'Windows', value: 'windows' }
  ]

  return {
    credentials: credentialOptions,
    connectionTypes: connectionTypeOptions,
    collectorTypes: collectorTypeOptions
  }
}

export default useOptions